import {useThemes} from "../../style/themes.hook";
import {graphql, useStaticQuery} from "gatsby";
import {ThemeProvider} from "styled-components";
import {Heading4, MaxWidthContainer, Paragraph} from "../../style/itf-styled-components";
import {FestivalCategory} from "../festival-category";
import Img from "gatsby-image/withIEPolyfill";
import React from "react";
import {Section} from "./section";
import {useWemembers} from "../../data/hooks/members";
import {MembersAvatarList} from "../members-avatar-list";

export const WeimagineSection = () => {
  const themes = useThemes();
  const images = useStaticQuery(graphql`
        query weImagine {
          weimage: file(relativePath: { eq: "photo-shooting-studio-girl.png" }) {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          },
        }`
  );

  return (
    <ThemeProvider theme={themes.light}>
      <MaxWidthContainer
        as={Section}
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 100px;

          @media (max-width: ${props => props.theme.mobileWidth}) {
            display: flex;
            flex-direction: column;
          }
        `}
      >
        <div>
          <span css={`font-size: 2em;`}>
            <FestivalCategory category={"we"}/>
          </span>
          <Heading4>Fotografie de nuntă și eveniment</Heading4>
          <Paragraph>În 2021, ne-am propus să demonstrăm că fotografia de eveniment nu a murit odată cu pandemia, ci a evoluat și s-a adaptat. Secțiunea WeImagine vă aduce față în față cu personalități internaționale, multipremiate, din domeniul fotografiei de nuntă. Îi veți putea cunoaște în cadrul workshop-urilor și masterclass-urilor ITF WeImagine pe Victor Lax, Cafa Liu, Elena Haralabaki și mulți alții.</Paragraph>
        </div>
        <div
          css={`
            display: flex;
            justify-content: flex-end;

            @media (max-width: ${props => props.theme.mobileWidth}) {
              justify-content: center;
              margin-top: 50px;
            }
          `}
        >
          <Img
            css={`
              width: 100%;
              max-width: 424px;
            `}
            fluid={images.weimage.childImageSharp.fluid}
            objectPosition="50% top"
          />
        </div>
      </MaxWidthContainer>
      <MaxWidthContainer
        as={Section}
        css={`
          padding-bottom: 100px;
          padding-top: 0;
        `}
      >
        <MembersAvatarList speakers={useWemembers()}/>
      </MaxWidthContainer>
    </ThemeProvider>
  );
}